import { PageEditMode } from './page-edit-mode';
import { PageEditModeStatus } from './page-edit-mode-status';
import { AbstractPageComponent } from '../../components/bookviewer/page/abstract-page-component';
import { Page } from '../../models/page';

export class TestEditMode implements PageEditMode {

    type = 'TEST_EDIT';
    status: PageEditModeStatus;
    private pageComponent: AbstractPageComponent;

    constructor() {
        this.status = PageEditModeStatus['INIT'];
    }

    getPage(): Page {
        if (!this.pageComponent) {
            return undefined;
        }

        return this.pageComponent.page;
    }

    getResult(): any {
        return;
    }

    getStatus(): PageEditModeStatus {
        return this.status;
    }

    onMouseDown($event): void {
        return;
    }

    onMouseLeave($event): void {
        return;
    }

    onMouseMove($event): void {
        return;
    }

    onMouseUp($event): void {
        return;
    }

    onPinch($event): void {
        return;
    }

    setPage(page: AbstractPageComponent): void {
        return;
    }
}
